import { isSearchTextLengthInsufficient } from '../util';
import { getConfigProperty } from '@/common/oldMobile';
import axios from 'axios';
import Immutable from 'immutable';

export const SEARCH_RESULT_MATCHES_BOXSTORE = 'resultMatchesBoxStore';
export const SEARCH_RESULT_TOURNAMENTS_BOXSTORE = 'resultTournamentsBoxStore';

export const getMatchIds = function(resultData) {
    return resultData
        .filter(rd => rd.get('type') === 'L' || rd.get('type') === 'M' || rd.get('type') === 'R')
        .map(rd => rd.get('id'))
        .toOrderedSet();
};

export function callSearch(searchText) {
    if (isSearchTextLengthInsufficient(searchText)) {
        return Promise.resolve(Immutable.List());
    }
    const searchUrl = getConfigProperty('search.endpoint.url');

    return axios
        .get(searchUrl, {
            params: {
                text: searchText,
                offset: 0,
                count: 20,
                channel: 'MOBILE'
            }
        })
        .then(json => {
            const searchData = Immutable.fromJS(json.result);
            return Promise.resolve(searchData);
        })
        .catch(err => {
            console.warn(err);
            return Promise.resolve(Immutable.List());
        });
}
